// Module
var code = `<a ng-csv="employerActivityReportCsvExportCtrl.exportActivityReports()" csv-header="employerActivityReportCsvExportCtrl.csvData.headers" filename="{{employerActivityReportCsvExportCtrl.csvData.fileName}}" data-test-id="performance-report-btn"> {{ "ACTIVITY_REPORT_BUTTON" | translate }} </a> `;
// Exports
export default code;